<div class="wrapper-page wrapper-my-list">
  <tl-header></tl-header>
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <span>
        {{'LISTS.recommended_listers' | translate}}
      </span>
    </div>
  </div>
  <div class="wrapper-content-my-lists favorite-lists">
    <div class="content-my-lists">
      <div class="filter-my-lists">
        <div class="wrapper-custom-search">
          <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
          <input type="text" placeholder="{{'NEW_TEXT.search' | translate}}"  [(ngModel)]="searchTerm" (input)="onSearchChange($event)">
          <div (click)="resetSearch()" class="wrapper-delete-search">
            <img src="../../../assets/icons/outline/icon-close.svg" alt="">
          </div>
        </div>
      </div>
      <div class="scroll-pagination" #recommendedListersContainter (scroll)="onScroll()">
        <div *ngFor="let lister of recommendedListers" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, lister.username]" class="wrapper-card-lister">
          <div class="wrapper-favorite-lister">
            <div class="wrapper-avatar">
              <img *ngIf="lister.profile_photo_url === null"
                   [src]="(lister.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../../assets/images/avatar-user-expert.png' : '../../../../assets/images/avatar-user.png'"
                   alt="">
              <img *ngIf="lister.profile_photo_url !== null"
                   [src]="lister.profile_photo_url" alt="">
            </div>
            <div class="wrapper-user-info">
              <div class="wrapper-username">
                <span>{{lister.name}}</span>
                <img *ngIf="(lister.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../assets/icons/fill/icon-badge.svg" alt="">
                <img *ngIf="(lister.subscriptions | checkActiveRole) === UserRoles.company" src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
              </div>
              <span>{{lister.followers_count}} {{lister.followers_count === 1 ? ('GENERAL.followers'  | translate): ('GENERAL.followers' | translate)}}</span>
            </div>
          </div>
          <div class="wrapper-send-btn">
            <button class="custom-btn custom-btn--outline">
              <span>{{lister.lysts_count}} {{'GENERAL.lists' | translate}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
